import { Component, OnInit } from '@angular/core';
import { SharedServices } from './shared/shared.service';
import { NavigationEnd, Router } from '@angular/router';
import { SidebarService } from './shared/components/sidebar/sidebar.service';
import { FileService } from './services/file.service';
import { MatSnackBar } from '@angular/material/snack-bar';
import { environment } from 'src/environments/environments';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  phoneNumber: string = ''
  namePartner: string = ''
  userName: string = '';
  isSidebarExpanded = false;
  isExpanded = false;
  showSidebar = true; // controla si el sidebar se muestra u oculta
  showNavBottom = false;
  titleFromParent: string = ''
  showBanner: boolean = true
  platform: boolean = false;
  userRol: string | null = null;
  isMobile = false;
  private intentoLogin = false;

  constructor(
    private sharedService: SharedServices,
    private router: Router,
    private sidebarService: SidebarService,
    private fileService: FileService,
    private snackBar: MatSnackBar
  ) {
  }

  ngOnInit(): void {
    if (environment.name === 'biib') {
      this.setFavicon(`${environment.apiUrlImg}login.png`);
    }
    this.sharedService.wakeUpPortalAdmin();
    this.sharedService.wakeUpPortal();
    this.sharedService.wakeUpMipress();
    this.sharedService.wakeUpexportData();
    this.sharedService.wakeUpGenerarPdf();
    this.sharedService.wakePostIntegration();
    const hiddenSidebarRoutes = ['/login', '/login/otp', '/login/singup', '/validar-paciente'];

    this.sharedService.infoCompany$.subscribe(res => {
      this.phoneNumber = res.token;
      this.namePartner = res.code;

      this.router.events.subscribe(event => {
        if (event instanceof NavigationEnd) {
          const cleanUrl = event.urlAfterRedirects.split('?')[0];

          const isHiddenRoute = hiddenSidebarRoutes.includes(cleanUrl);

          // Volvemos a chequear tamaño de pantalla
          this.isMobile = window.innerWidth < 768;

          // Combinamos condiciones
          this.showSidebar = !this.isMobile && !isHiddenRoute;
          this.showNavBottom = this.isMobile && !isHiddenRoute;
          this.platform = this.isMobile && !isHiddenRoute;
          this.platform = this.isMobile || (this.fileService.getPlatform() == 'android' || this.fileService.getPlatform() == 'ios') && !isHiddenRoute;
        }
      });
    });

    this.sharedService.userLogin$.subscribe((res: any) => {
      this.titleFromParent = res.configRol.mensaje;
      this.intentoLogin = true;
      this.showBanner = res.rol == 'EPS'
      console.log(res);
      this.userRol = res.rol?.toLowerCase();
      if (['paciente', 'logistico'].includes(this.userRol ?? '')) {
        this.isExpanded = false;
        this.isSidebarExpanded = false;
        this.sidebarService.setExpanded(false); // si el servicio tiene este método
      }
    });

    this.sidebarService.isExpanded$.subscribe(expanded => {
      this.isSidebarExpanded = expanded;
    });

    // Inicial
    this.checkScreenSize();
    window.addEventListener('resize', this.checkScreenSize.bind(this));
  }
  showErrorMessage(message: string) {
    this.snackBar.open(message, 'X', {
      duration: 7000,
      panelClass: ['custom-snackbar'],
      verticalPosition: 'top',
      horizontalPosition: 'center',
    });
  }
  private setFavicon(iconUrl: string) {
    let link = document.querySelector("link[rel*='icon']") as HTMLLinkElement;

    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      link.type = 'image/x-icon';
      document.head.appendChild(link);
    }

    link.href = iconUrl;
  }
  checkScreenSize() {
    const hiddenSidebarRoutes = ['/login', '/login/otp', '/login/singup', '/validar-paciente'];
    const isHiddenRoute = hiddenSidebarRoutes.includes(this.router.url);

    this.isMobile = window.innerWidth < 768;

    this.showSidebar = !this.isMobile && !isHiddenRoute;
    this.showNavBottom = this.isMobile && !isHiddenRoute;
    this.platform =
      (this.isMobile || this.fileService.getPlatform() == 'android' || this.fileService.getPlatform() == 'ios')
      && !isHiddenRoute;
  }
  // Cambio 2: guard en sidebarVisible()
  sidebarVisible(): boolean {
    if (!this.userRol) return false;
    return this.showSidebar && !['paciente', 'logistico'].includes(this.userRol);
  }

  isAuthRoute(): boolean {
    return ['/login', '/login/otp', '/login/singup', '/validar-paciente'].includes(this.router.url);
  }

  toggleSidebar(expanded: any) {
    this.isExpanded = expanded;
  }

}
